(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tiktok-pixel"] && !Shopify.designMode) return;
  try {
    !function (w, d, t) {
  w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
  ttq.load('DA443DJC77U14HQM61V0');
  ttq.page();

  document.addEventListener('DOMContentLoaded', function() {
    // AddToCart tracking з автоматичним зчитуванням ID товару
    var addForms = document.querySelectorAll('form[action*="/cart/add"]');
    addForms.forEach(function(form) {
      form.addEventListener('submit', function() {
        var idInput = form.querySelector('input[name="id"], select[name="id"]');
        var variantId = idInput ? idInput.value : '';

        ttq.track('AddToCart', {
          "content_type": "product",
          "content_id": variantId,
          "contents": [
            {
              "content_id": variantId,
              "content_type": "product"
            }
          ]
        });
      });
    });

    // InitiateCheckout tracking
    var checkoutButtons = document.querySelectorAll('form[action*="/cart"] button[name="checkout"], form[action*="/cart"] input[name="checkout"], a[href*="/checkout"]');
    checkoutButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        ttq.track('InitiateCheckout');
      });
    });
  });
}(window, document, 'ttq');
  } catch(e) { console.error(e); }
})();

})();
